export const API_URL = {
  //------ project docs
  CREATE_PROJECT_DOCUMENTS: '/project-documents/add',
  DELETE_PROJECT_DOCUMENTS: '/project-documents/remove',

  GET_SKILLS: '/skill/getAllSkills/',
  GET_SKILLS_FROM_JD: '/employee/extract-tools',
  UPDATE_SKILLS: '/skill/updateSkillName',
  DELETE_SKILLS: '/skill/remove',
  DELETE_MULTIPLE_SKILLS: '/skill/removeMultipleSkills',

  GET_EMPLOYEES: '/engagementManager/getEmployees',
  CREATE_EMPLOYEE: '/employee',
  UPDATE_EMPLOYEE: '/employee',
  DELETE_EMPLOYEE: '/employee/deleteEmployee',
  DELETE_EMPLOYEE_FORCEFULLY: '/employee/forceDeleteEmployee',
  ACTIVATE_EMPLOYEE: '/employee/enableEmployee',
  GET_EMPLOYEES_BY_ID: '/employee/getEmployeeById',
  VALIDATE_EMAIL_EXISTS: '/employee/verify-email',
  GET_EMPLOYEES_OFFBOARDING_BY_DEPARTMENT: '/employees/boardings/getMyDeptOffBoard',
  GET_ALL_EMPLOYEES_OFFBOARDING: '/employees/boardings/getAllOffBoard',
  INITIATE_OFFBOARD_EMPLOYEE: '/employees/boardings/save',
  DESTROY_EMPLOYEE_OFFBOARD_REQ: '/employees/boardings/destroy',
  UPDATE_EMPLOYEE_SATURDAYS: '/employee/updateSaturdaysOfMultipleEmployees',

  GET_PROJECT_MANAGERS: '/employee/getProjectManagers',
  GET_DIVISIONS: '/division/get',

  GET_ENGAGEMENT: '/engagementManager/getWithSkills',
  ADD_ENGAGEMENT: '/engagementManager/add',
  DELETE_ENGAGEMENT: '/engagementManager/remove',

  GET_ALL_EMPLOYEES: '/permission/getEmployees',
  ADD_EMPLOYEE_PERMISSIONS: '/permission/add',
  GET_USER_PERMISSIONS: '/permission/get',

  DELETE_RESUME: '/employee-resume/resumeDeleteById',

  GET_PORTFOLIO: '/projectPortfolio/get',
  SAVE_PORTFOLIO: '/projectPortfolio/save',
  UPDATE_PORTFOLIO: '/projectPortfolio/update',
  UPDATE_PORTFOLIO_ATTACHMENTS: '/projectPortfolio/updateUploads',
  ADD_PORTFOLIO_ATTACHMENTS: '/projectPortfolio/updateAddUploads',
  FULL_UPDATE_PORTFOLIO: '/projectPortfolio/updateFullComponentPortfolio',

  GET_FORM_DATA: '/monthlyAudit/getMonthlyForm',
  SAVE_AUDIT_FORM: '/monthlyAudit/addMonthlyForm',
  UPDATE_AUDIT_FORM: '/monthlyAudit/updateMonthlyForm',

  VERY_ASSET_FORM_URL: '/monthlyAudit/verifyFormSubmission',
  COMPANY_DIVISION: '/executiveSummary/company-division',
  BILLING_STATUS: '/executiveSummary/billingStatus',
  SENIORITY: '/executiveSummary/seniority',
  ENGINEERING: '/executiveSummary/engineering',

  HEADCOUNT: '/executiveSummary/headCount',
  ONBOARDING: '/executiveSummary/onBoardingDetails',
  OFFBOARDING: '/executiveSummary/offBoardingDetails',

  GET_DEPARTMENTS: '/department/getDepartments',
  GET_DIVISIONS: '/division/get',
  GET_NOTIFICATIONS: '/notifications',
  GET_UNREAD_NOTIFICATIONS_COUNT: '/notifications/unread-count', // API URL for unread notifications count
  READ_ALL_NOTIFICATIONS: 'notifications/readAll',
  READ_USER_NOTIFICATION: 'notifications/update',

  GET_EVALUATIONS: '/evaluation/getEvaluations',
  COMPLETE_PROCESS: '/evaluation/completeProcess',
  GET_COMPONENT: '/evaluation/getComponent',
  GET_REVIEWS: '/evaluation/getReviews',
  ADD_FEEDBACK: '/evaluation/addReview',
  UPDATE_FEEDBACK: '/evaluation/updateReview',
  INITIATE_REVIEW: '/evaluation/initiateReview',
  SEND_REQUEST: '/evaluation/requestForFeedback',
  ACCEPT_REQUEST: '/evaluation/acceptNotification',
  DEFER_PROCESS: '/evaluation/deferProcess',
  CLOSE_RETENTION: '/evaluation/closeRetention',
  GET_EVALUATION_PM: '/evaluation/getProjectManagersData',
  GET_HOME_EVALUATIONS: '/evaluation/getEvaluationsForHome',
  HOD_PROCESS: '/evaluation/hodProcess',

  GET_SKILL_REQUEST_DATA: '/monthlyAudit/getSkillRequests',
  ACCEPT_SKILL_REQUEST: '/monthlyAudit/acceptSkillRequest',
  REJECT_SKILL_REQUEST: '/monthlyAudit/rejectSkillRequest',
  GET_AUDIT_DETAILS: '/monthlyAudit/getAuditsReport',

  GET_ALL_DELETED_LEAVES_HR: '/employeeLeaves/getAllDeletedLeavesForHr',
  GET_ALL_SYSTEM_DELETED_LEAVES_HR: '/employeeLeaves/getAllSystemGeneratedDeletedLeaves',
  GET_ALL_LEAVES_HR: '/employeeLeaves/getAllLeavesForHr',
  DELETE_LEAVE_BY_HR: '/employeeLeaves/deleteAppliedLeave/',
  CHECK_APPLIED_LEAVE: '/employeeLeaves/checkSandwhichAppliedLeave',
  DELETE_LEAVE: '/employeeLeaves/deleteLeave/',
  UPDATE_LEAVE_STATUS_HR: 'employeeLeaves/updateLeaveStatusByHr',
  SEND_NOTIFICATION_TO_PMs: 'employeeLeaves/sendLeaveNotificationToPMs',
  SYSTEM_LEAVES_HR: 'employeeLeaves/getAllSystemGeneratedLeavesForHr',
  SYSTEM_LEAVES_PM: 'employeeLeaves/getAllSystemGeneratedLeavesForPm',
  CREATE_GIFT_LEAVE: 'giftLeaves/create',
  GET_GIFT_LEAVES: '/giftLeaves/getAll',
  GET_ALL_DELETED_GIFT_LEAVES_HR: '/giftLeaves/getAllDeletedLeaves',
  DELETE_GIFT_LEAVE: '/giftLeaves/deleteGiftLeave/',
  CHECK_PUBLIC_LEAVES: '/employeeLeaves/checkAppliedLeave',

  GET_ALL_RESOURCES: 'employee/getAllResources',

  CREATE_DEPARTMENT: '/department/save',
  GET_DEPARTMENTS_NEW: '/department/get',
  DELETE_DEPARTMENT: '/department/destroy',
  UPDATE_DEPARTMENT: '/department/update',
  CREATE_SUB_DEPARTMENT: '/sub-department/save',
  DELETE_SUB_DEPARTMENT: '/sub-department/destroy',
  UPDATE_SUB_DEPARTMENT: '/sub-department/update',
  GET_DEPARTMENT_RESOURCE_COUNT: '/department/getEmployeeCount',
  REPLACE_SUB_DEPARTMENT: '/department/replaceDepartmentId',
  //---Public holidays -------
  SAVE_PUBLIC_HOLIDAY: '/publicholiday/save',
  GET_PUBLIC_HOLIDAY: '/publicholiday/get',
  UPDATE_PUBLIC_HOLIDAY: '/publicholiday/update',
  DESTROY_PUBLIC_HOLIDAY: '/publicholiday/destroy',
  REPEAT_PUBLIC_HOLIDAY: '/publicholiday/repeat',

  GET_DESIGNATIONS: '/designations/get',
  CREATE_DESIGNATION: '/designations/save',
  DELETE_DESIGNATION: '/designations/destroy',
  UPDATE_DESIGNATION: '/designations/update',
  REPLACE_DELETE_DESIGNATION: '/designations/replaceDestroy',

  GET_DESIGNATION_LEVELS: '/designationLevels/get',
  CREATE_DESIGNATION_LEVEL: '/designationLevels/save',
  DELETE_DESIGNATION_LEVEL: '/designationLevels/destroy',
  UPDATE_DESIGNATION_LEVEL: '/designationLevels/update',

  GET_REQUEST_LOANS: '/loans/get',
  APPLY_LOAN: '/loans/apply',
  GET_MY_LOANS: '/loans/getMyloans',
  UPDATE_LOAN_STATUS: '/loans/updateStatus',
  UPDATE_LOAN: '/loans/update',
  ADD_ATTACHMENTS: '/loans/addAttachments',
  GET_LOAN_INSTALLMENTS: '/loans/my-instalments',
  GET_ALL_LOAN_INSTALLMENTS: '/instalments/all-instalments',
  PAUSE_INSTALLMENTS: '/instalments/pause',
  GET_ATTACHMENTS: '/loansAttachments',
  GET_LOAN_INSTALLMENTS_HISTORY: '/instalments/all-instalments-history',
  UPDATE_INSTALLMENT_AMOUNT: '/instalments/updateInstalment',
  UPDATE_RESOURCE_FEEDBACK_LOAN: '/loans/updateHrFeedbackForResource',
  DELETE_RESOURCE_LOAN: '/loans/deleteLoan',
  MANUAL_LOAN_UPDATE: '/loans/updateManualLoan',
  GET_ALL_LOANS_HR: '/loans/getAllLoans',
  GET_LOANS_REQUEST_HR_HOD: '/loans/getLoansActionNeeded',

  // Offline Time Module
  CREATE_OFFLINE_TIME_REQUEST: '/timeRequest/saveTimeRequest',
  GET_OFFLINE_TIME_REQUEST: '/timeRequest/getTimeRequest',
  GET_MY_OFFLINE_TIME_REQUEST: '/timeRequest/resourceRequests',
  UPDATE_OFFLINE_TIME_REQUEST: '/timeRequest/updateStatus',
  GET_IT_PERSONS: '/timeRequest/getITResource',
  DELETE_OFFLINE_REQUEST: '/timeRequest/destroy',

  // Claim Module
  GET_CLAIMS: '/employee-claims/getEmployeeClaims',
  CREATE_CLAIM: '/employee-claims/addEmployeeClaim',
  UPDATE_CLAIM: '/employee-claims/updateEmployeeClaim',
  DELETE_CLAIM: '/employee-claims/deleteEmployeeClaim',
  UPDATE_CLAIM_STATUS: '/employee-claims/changeEmployeeClaimStatus',
  GET_MANAGERS: '/employee/managers',
  GET_VALID_HOURS: '/employee-claims/getRequiredWeeklyMinutes',
  GET_CLAIM_INFO: '/employee-claims/getRequestedClaimInfo',
  GET_WEEK_ATTENDANCE: '/employee-attendance/all',
  GET_B_FORM: '/employee-claims/getBForm',
  UPDATE_MEDICAL_CLAIM_ATTACHMENTS: '/employee-claims/updateMedicalStatus',
  UPDATE_ATTACHMENT_AMOUNT_BY_HR: '/employee-claims/updateMedicalAttachmentByHr',
  UPDATE_CLAIM_AMOUNT_BY_HR: '/employee-claims/hrUpdateAmount',
  GET_OT_CLAIMS: '/employee-claims/getEmployeeClaimsOTByRole',
  GET_CLAIMS_DEADLINE: '/employee-claims/getClaimDeadlines',
  ADD_CLAIMS_DEADLINE: '/employee-claims/addClaimDeadline',
  DOWNLOAD_CSV: '/employee-claims/downloadClaims',

  APPLY_HARDWARE_LOSS: '/hardwareLossTickets/create',
  GET_ALL_HARDWARE_LOSS: '/hardwareLossTickets/getAll',
  GET_MY_HARDWARE_REQUESTS: '/hardwareLossTickets/getResourceTickets',
  CREATE_MY_HARDWARE_REQUESTS: '/hardwareLossTickets/createMyTicket',
  GET_MY_ASSETS_DETAIL: 'hardwareLossTickets/getResourceAssets',
  UPDATE_INSTALLMENT_PLAN: '/hardwareLossTickets/updatedByResource',
  UPDATE_MY_TICKET: '/hardwareLossTickets/updateMyTicket',
  DELETE_MY_TICKET: '/hardwareLossTickets/delete',
  UNASSIGNED_TICKET: '/hardwareLossTickets/createUnAssigned',
  ACTION_ON_UNASSIGNED: '/hardwareLossTickets/takeActionOnUnAssignedTicket',
  GET_UNASSIGNED_REQUESTS: '/hardwareLossTickets/getAllUnAssigned',
  UPDATE_TICKET_STATUS: '/hardwareLossTickets/updateStatus',
  TICKET_BY_IT_HEAD: '/hardwareLossTickets/updateFinalCost',
  TICKET_BY_IT: '/hardwareLossTickets/update',
  TICKET_BY_HR: '/hardwareLossTickets/notifyResource',
  TICKET_BY_SYS_HEAD: '/hardwareLossTickets/updateResourceTicket',
  GET_WEEK_ATTENDANCE: '/employee-attendance/all',
  NIGHT_SHIFT_EMPLOYEES: '/employee-attendance/getNightShiftEmployees',

  DELETE_ONBOARDING_PROJECT: '/projectOnBoarding/delete',
  ARCHIVED_ONBOARDING_PROJECT: '/projectOnBoarding/archiveProject',
  CHANNEL_CREATED_ONBOARDING_PROJECT: '/projectOnBoarding/updateChannelCreated',

  VALIDATE_ONBOARDING_PROJECT_EXISTS: '/projectOnBoarding/verifyProjectName',

  GET_WEBHOOKS: '/webhooks/get',
  CREATE_WEBHOOK: '/webhooks/save',
  DELETE_WEBHOOK: '/webhooks/destroy',
  UPDATE_WEBHOOK: '/webhooks/update',
  RETRY_WEBHOOK: '/webhooks/retry',
  TEST_WEBHOOK: '/webhooks/test',
  GET_WEBHOOK_LOGS: '/webhooks/logs',

  GET_REQUEST_POSITION_OPENINGS: '/positionOpenings/all-position-opening-requests',
  ADD_REQUEST_POSITION_OPENING: '/positionOpenings/create-position-opening-request',
  UPDATE_REQUEST_POSITION_OPENING: '/positionOpenings/update-position-opening-request',
  GET_ROLE_BASED_REQUEST_POSITION_OPENINGS: '/positionOpenings/role-based-position-opening-requests',
  CHANGE_STATUS_REQUEST_POSITION_OPENING: '/positionOpenings/update-status-opening-request',
  DELETE_REQUEST_POSITION_OPENING: '/positionOpenings/delete-request',
  SEND_REMINDER: '/positionOpenings/send-reminder',
  UPDATE_FIELDS_RECRUITER: '/positionOpenings/update-fields-request',

  SEND_REMINDER_TO_PM: '/employee-claims/sendReminderToPm',
  GET_PENDING_OVERTIME_FROM_PM: '/employee-claims/getPendingOvertimeFromPm',

  CREATE_SUPPORT_TICKET: '/supportTickets/create',
  UPDATE_SUPPORT_TICKET: '/supportTickets/update',
  DELETE_SUPPORT_TICKET: '/supportTickets/delete',
  GET_ALL_TICKETS: '/supportTickets/getAll',
  GET_MANAGER_TICKETS: '/supportTickets/getCCEmployeeTickets',
  GET_USER_TICKETS: '/supportTickets/getAllByEmployee',
  GET_ASSIGNED_TICKETS: '/supportTickets/getAssignedTickets',
  RESOLVE_USER_TICKET: '/supportTickets/resolveTicket',
  RESOLVE_MANAGER_TICKET: '/supportTickets/pmFeedback',
  TRANSFER_TICKET: '/supportTickets/forwardTicket',
  ASSIGN_TICKET: '/supportTickets/assignTicket',
  REOPEN_TICKET: '/supportTickets/reopen',

  GET_ALL_DOMAINS: '/domains/getDomains',
  UPDATE_DOMAIN: '/domains/updateAssignee',
  REFRESH_DOMAIN: '/domains/refreshDomain',
  MAKE_LEAVE_ENCASHMENT_REQEST: '/employeeLeaves/leaves-encashment',
  GET_LEAVES_ENCASHMENT_AND_CARRY_FORWARD_DETAILS: '/employeeLeaves/get-leaves-encashment-carryForward-details',
};
